module.exports = __webpack_public_path__ + "img/y-5.9934a54d.jpg";